import styles from "./Header.module.css";
import header from "@/assets/images2/header.jpg";
import NavBar from "../NavBar";
import { useDispatch, useSelector } from "react-redux";
import {
  getForgeRockAuthInfo,
  selectParentHeaderAndFooterData,
  setUserLoggedinId,
} from "../../redux/dataSlice";
import { processHeader } from "../../utils/parentMapping";
import { useEffect } from "react";
import useMobileDevice from "@/hooks/useMobileDevice";
import usePicklist from "@/hooks/usePicklist";
import useSchoolList from "@/hooks/useSchoolList";

const Header = (data) => {
  const dispatch = useDispatch();

  useMobileDevice();
  usePicklist();
  useSchoolList();

  const processedData = processHeader(data?.data?.data);

  const userAuthInfo = useSelector(getForgeRockAuthInfo);
  const sfid = userAuthInfo?.educationId;

  useEffect(() => {
    if (sfid) {
      dispatch(setUserLoggedinId(sfid));
    }
  }, [sfid]);

  return (
    <>
      <div
        style={{
          backgroundImage: `url(${processedData?.backgroundimage ?? header})`,
        }}
        className={`${styles.banner} `}
        data-testid="header-container-id"
      >
        <div className={`${styles.overlay}`}></div>
        <div className="container h-100">
          <div className="d-flex flex-column h-100">
            <NavBar data={processedData} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
